<dcp-cyber-source-device-data-collection-form [deviceDataCollectionSetup]="deviceDataCollectionSetup" ></dcp-cyber-source-device-data-collection-form>
